import types from './types';

export default {
  showModal: (component, props = {}) => ({
    component,
    props,
    type: types.SHOW_MODAL,
  }),
  hideModal: () => ({
    type: types.HIDE_MODAL,
  }),
};



// WEBPACK FOOTER //
// ./src/app/actions/modal/index.js